let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("67AMp")).then(() => parcelRequire('f59Fu'));